// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"9d8d63fd573d46722642","147":"aed6b03124b6a7704925","251":"90efc32b8e56c61893f2","265":"bdab3b8250d5ce5ad886","352":"541869d734d8a64d6c3a"}[chunkId] + ".js";
};